export default __webpack_public_path__ + "static/media/JanusHenderson.dcffecb2.png";